import $ from 'jquery';
import mediator from './mediator';

var configureHeroBG = function configureHeroBG() {
  var screenSize = window.cigna.screen.breakpoint;
  var accentHeights = [];
  var introHeroHeight = []; // Get Legal Lines and Meta Accent heights to make photo float in mobile

  $('.hero-long-intro .accent-small').each(function (i, e) {
    var accentDiv = $(e);
    accentHeights.push(accentDiv.outerHeight(true));
  });
  $('.hero-long-intro .container').each(function (i, e) {
    var containerDiv = $(e);
    introHeroHeight.push(containerDiv.outerHeight(true));
  });
  var floatPhotoAccentHeight = $('.hero-floating-photo .hero-floating-photo-optional-content').outerHeight(true) || 0;
  var totalAccentHeight = accentHeights.reduce(function (a, b) {
    return a + b;
  }, 0);
  var totalIntroHeroHeight = introHeroHeight.reduce(function (a, b) {
    return a + b;
  }, 0);
  $('.hero-white-left-box, .hero-white-left-box-green-stroke').removeClass('d-none');

  switch (screenSize) {
    case 'xs':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-xs-bg'), ")"),
        height: '144px'
      });
      $('.hero-long-intro').css('background-size', "100% calc(".concat($('.long-intro-content').outerHeight(true), "px + ").concat(totalAccentHeight, "px + 184px + 1.5rem)"));
      $('.hero-floating-photo').css('background-size', "100% calc(".concat($('.hero-floating-photo-main-content').outerHeight(true), "px + ").concat(floatPhotoAccentHeight, "px + 184px + 3rem)"));
      $('.hero-white-left-box').css({
        left: '0',
        'max-width': '100%'
      });
      $('.hero-full-width-photo:not(.hero-full-width-green-stroke)').css('margin-bottom', '3rem');
      $('.hero-bg-green-stroke').css({
        'background-image': "url(".concat($('.hero-bg-green-stroke').attr('data-xs-bg'), ")"),
        height: '113px'
      });
      break;

    case 'sm':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-sm-bg'), ")"),
        height: '192px'
      });
      $('.hero-long-intro').css('background-size', "100% calc(".concat($('.long-intro-content').outerHeight(true), "px + ").concat(totalAccentHeight, "px + 284px + 3rem)"));
      $('.hero-floating-photo').css('background-size', "100% calc(".concat($('.hero-floating-photo-main-content').outerHeight(true), "px + ").concat(floatPhotoAccentHeight, "px + 284px + 3rem)"));
      $('.hero-white-left-box').css({
        left: '0',
        'max-width': '100%'
      });
      $('.hero-full-width-photo:not(.hero-full-width-green-stroke)').css('margin-bottom', '3rem');
      $('.hero-bg-green-stroke').css({
        'background-image': "url(".concat($('.hero-bg-green-stroke').attr('data-sm-bg'), ")"),
        height: '258px'
      });
      break;

    case 'md':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-md-bg'), ")"),
        height: '248px'
      });
      $('.hero-long-intro').css('background-size', "100% calc(".concat($('.long-intro-content').outerHeight(true), "px + ").concat(totalAccentHeight, "px + 284px + 3rem)"));
      $('.hero-white-left-box').css({
        left: 'calc((100% - 724px + 2rem) / 2)',
        'max-width': 'calc((100% - (100% - 724px + 4rem)) * .5)'
      });
      $('.hero-full-width-photo:not(.hero-full-width-green-stroke)').css('margin-bottom', "calc((".concat($('.hero-white-left-box:visible').outerHeight(true), "px - (248px - 2rem)) + 3rem)"));
      $('.hero-bg-green-stroke').css({
        'background-image': "url(".concat($('.hero-bg-green-stroke').attr('data-md-bg'), ")"),
        height: "calc(".concat($('.hero-white-left-box-green-stroke').outerHeight(true), "px + 72px)")
      });
      break;

    case 'lg':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-lg-bg'), ")"),
        height: '284px'
      });
      $('.hero-long-intro').css('background-size', "100% calc(".concat($('.long-intro-content').outerHeight(true), "px + ").concat(totalAccentHeight, "px + 284px + 3rem)"));
      $('.hero-white-left-box').css({
        left: 'calc((100% - 964px + 2rem) / 2)',
        'max-width': 'calc((100% - (100% - 1144px + 1rem)) * .4166)'
      });
      $('.hero-full-width-photo:not(.hero-full-width-green-stroke)').css('margin-bottom', "calc((".concat($('.hero-white-left-box:visible').outerHeight(true), "px - (284px - 2rem)) + 3rem)"));
      $('.hero-bg-green-stroke').css({
        'background-image': "url(".concat($('.hero-bg-green-stroke').attr('data-lg-bg'), ")"),
        height: "calc(".concat($('.hero-white-left-box-green-stroke').outerHeight(true), "px + 72px)")
      });
      break;

    case 'xl':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-lg-bg'), ")"),
        height: '360px'
      });
      $('.hero-white-left-box').css({
        left: 'calc((100% - 1144px + 2rem) / 2)',
        'max-width': 'calc((100% - (100% - 1144px + 1rem)) * .4166)'
      });
      $('.hero-full-width-photo:not(.hero-full-width-green-stroke)').css('margin-bottom', "calc((".concat($('.hero-white-left-box:visible').outerHeight(true), "px - (360px - 3rem)) + 3rem)"));
      $('.hero-long-intro').css('background-size', "100% calc(".concat(totalIntroHeroHeight, "px - 72px)"));
      $('.hero-bg-green-stroke').css({
        'background-image': "url(".concat($('.hero-bg-green-stroke').attr('data-lg-bg'), ")"),
        height: "calc(".concat($('.hero-white-left-box-green-stroke').outerHeight(true), "px + 72px)")
      });
      break;

    default:
      break;
  }
};

export var initialHeroBG = function initialHeroBG() {
  var screenSize = window.cigna.screen.breakpoint;

  switch (screenSize) {
    case 'xs':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-xs-bg'), ")"),
        height: '144px'
      });
      break;

    case 'sm':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-sm-bg'), ")"),
        height: '192px'
      });
      break;

    case 'md':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-md-bg'), ")"),
        height: '248px'
      });
      break;

    case 'lg':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-lg-bg'), ")"),
        height: '284px'
      });
      break;

    case 'xl':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-lg-bg'), ")"),
        height: '360px'
      });
      break;

    default:
      break;
  }

  if ($('.hero-white-left-box.mycigna-OEP_li-hero').length) {
    import('./hero-mycigna-login').then(function (module) {
      module.default();
      configureHeroBG();
    }) // eslint-disable-next-line no-unused-vars
    .catch(function (error) {
      return 'An error occurred while loading form-validtator';
    });
  } else {
    configureHeroBG();
  }

  mediator.on('window:throttledResize', configureHeroBG);
};
export default (function () {
  $(document).ready(initialHeroBG);
});